
import { AccountCategory } from "./accountcategory";
import { AssignedPlanOptionRule } from "./assignedplanoptionrule";
import { ChangeTracked } from "./changetracked";
import { MasterTask } from "./mastertask";
import { TaskOption } from "./taskoption";
import { Template } from "./template";

export class TemplateTask {
    templateTaskId: number;
    templateId: number;
    masterTaskId: number;
    startDay: number;
    duration?: number = 1;
    paymentTrigger?: number = null;
    isActive: boolean = true;
    isPendingRemoval: boolean = false;
    isAdd: boolean;

    template: Template;
    masterTask: MasterTask;
    options?: TaskOption[] & ChangeTracked<TaskOption[]>;
    assignedPlanOptionRules?: AssignedPlanOptionRule[] & ChangeTracked<AssignedPlanOptionRule[]>;

    acctCat: AccountCategory;

    //For column sort functionality
    acctCatSort: string;
    taskNameSort: string;
}
